import { FormattedPostDataType } from 'pages/customer/detail/customerDetailsT1/edit/type';
import { ICustomerDetail } from 'pages/customer/detail/customerDetailsT1/type';
import { IDetailsCustomerFormatNumber, IUpdateCustomerFormatNumber } from 'pages/formatNumber/type';
import {
  IRequestType, ICustomerData, Code, IPerfecture, IReverberationInfo, AdvanceSearchFormType, IAdvancedSearchData, IAdvancedSearchSaveParams, IReserberationCourse, IReserberationStaff,
} from 'pages/customer/type';
import { getSessionStorage } from 'utility/browserStorageUtil';
import { IFeatureCode } from 'types/global';
import { IKarteCounselingFlag } from 'pages/customer/detail/electronicMedicalRecord/type';
import { IFormMedicalRecord, IMedicalRecordDetail, IFormMedicalRecordUpdate } from 'pages/customer/detail/electronicMedicalRecord/edit/type';
import { IReservationHistory, IReservationHistoryParams } from 'pages/customer/detail/productSalesPurchaseHistoryT6/type';
import { IParamsCreateApiAttachedSheet } from 'pages/customer/detail/attachedSheet/type';
import { ContractFlatRateResponse } from 'pages/customer/detail/flatRateContract/type';
import moment from 'moment';
import ApiClient from './ApiClient';

export const getCustomersListApi = async (params: { customerName?: string, customerNoOrManagementNo?: string, keyWord?: string, organizationName?: string, orgIds?: string[], applyForUnderOrg?: boolean, targetDate?: string, featureCode?: IFeatureCode }): Promise<ICustomerData[]> => {
  const companyCode = getSessionStorage('companyCode');
  const arrToStr = params?.orgIds ? [...params.orgIds].reduce((str, item) => (item.trim() !== '' ? `${str}&orgIds=${item}` : str), '') : '';
  const paramsAfter = params; delete paramsAfter.orgIds;
  const { data } = await ApiClient.get(`/v1/customers/${companyCode}?${arrToStr}`, { ...paramsAfter });
  return data;
};

export const getCustomersListApiUnderOrg = async (params: { customerName?: string, keyWord?: string, orgIds?: string, applyForUnderOrg?: boolean, targetDate?: string, featureCode?: IFeatureCode, customerNoOrManagementNo?:string, customerNoOrManagementNoOrCustomerName?:string, }): Promise<ICustomerData[]> => {
  if (!params?.orgIds) {
    // eslint-disable-next-line no-param-reassign
    delete params.orgIds;
    // eslint-disable-next-line no-param-reassign
    params.applyForUnderOrg = false;
  }
  const companyCode = getSessionStorage('companyCode');
  const { data } = await ApiClient.get(`/v1/customers/${companyCode}?`, { ...params });
  return data;
};

export const getCustomersListApiUnderOrgV2 = async (params: { page: number, size: number, customerName?: string, keyWord?: string, orgIds?: string, applyForUnderOrg?: boolean, targetDate?: string, featureCode?: IFeatureCode, customerNoOrManagementNo?:string, customerNoOrManagementNoOrCustomerName?:string, }): Promise<{ contents: ICustomerData[], currentPage: number, totalItem: number, totalPage: number }> => {
  if (!params?.orgIds) {
    // eslint-disable-next-line no-param-reassign
    delete params.orgIds;
    // eslint-disable-next-line no-param-reassign
    params.applyForUnderOrg = false;
  }
  const companyCode = getSessionStorage('companyCode');
  const { data } = await ApiClient.get(`/v2/customers/${companyCode}?`, { ...params });
  return data;
};

// Delete Customer
export const deleteCustomerApi = async (queryString: string): Promise<ICustomerData[]> => {
  const companyCode = getSessionStorage('companyCode');
  const { data } = await ApiClient.delete(`/v1/customers/${companyCode}`, queryString);
  return data;
};
// ImportCSV
export const importCSVCustomerApi = async (file: File): Promise<void> => {
  const companyCode = getSessionStorage('companyCode');
  const { data } = await ApiClient.postMutipartData(`/v1/customers/csv/${companyCode}`, {}, { uploadFile: file });
  return data;
};
// Get JobCode
export const getJobCodeApi = async (): Promise<Code[]> => {
  const { data } = await ApiClient.get('/v1/customers/jobs', {});
  return data;
};
// Get All Prefecture
export const getPrefectureListApi = async (): Promise<Code[]> => {
  const { data } = await ApiClient.get('/v1/customers/prefectures', {});
  return data;
};
// Add Customer
export const addCustomerApi = async (params: FormattedPostDataType) => {
  const { data } = await ApiClient.postJsonData('/v1/customers/', {}, params);
  return data;
};

// Get Customer Details
export const getCustomerDetailsApi = async (customerBasicDataId: string): Promise<ICustomerDetail> => {
  const companyCode = getSessionStorage('companyCode');
  const { data } = await ApiClient.get(`/v1/customers/${companyCode}/${customerBasicDataId}`, {});
  return data;
};

// 顧客の新規/既存判定 (反響情報の初回来店日有無による)
export const getCustomerTypeApi = async (
  customerBasicDataId: string,
): Promise<{ customerClass: 'NEW_CUSTOMER' | 'OLD_CUSTOMER'; firstVisitDate: string | null }> => {
  const { data } = await ApiClient.get(`/v1/customers/${customerBasicDataId}/customerType`, {});
  return data;
};
// Update Customer
export const updateCustomerApi = async (params: FormattedPostDataType) => {
  const { data } = await ApiClient.putJsonData('/v1/customers/', {}, params);
  return data;
};
// get Prefecture by Portal Code
export const getPerfectureByPostalCodeApi = async (postalCode: string): Promise<IPerfecture> => {
  const { data } = await ApiClient.get('/v1/customers/postalCode', { postalCode });
  return data;
};

export const postAdvancedSearchApi = async (params: AdvanceSearchFormType): Promise<ICustomerData[]> => {
  const { data } = await ApiClient.postJsonData('/v1/customers/dynamicQuery', {}, params);
  return data;
};
export const getAdvancedSearchListApi = async (): Promise<IAdvancedSearchData[]> => {
  const { data } = await ApiClient.get('/v1/customers/customerSearchConditions', {});
  return data;
};
export const postAdvancedSearchSaveConditionApi = async (condition: IAdvancedSearchSaveParams): Promise<IAdvancedSearchData> => {
  const { data } = await ApiClient.postJsonData('/v1/customers/customerSearchConditions', {}, condition);
  return data;
};

// get Customer Advanced search detail
export const getAdvancedSearchDetailApi = async (customerSearchId: string): Promise<IAdvancedSearchData> => {
  const { data } = await ApiClient.get(`/v1/customers/customerSearchConditions/${customerSearchId}`, {});
  return data;
};

export const deleteAdvancedSearchApi = async (customerSearchConditionIds: string): Promise<IAdvancedSearchData> => {
  const { data } = await ApiClient.delete('/v1/customers/customerSearchConditions/', customerSearchConditionIds);
  return data;
};
// get Details Number Format Setting
export const getDetailsCustomerNumberFormatApi = async (): Promise<IDetailsCustomerFormatNumber> => {
  const { data } = await ApiClient.get('/v1/customerNumberFormatApi', {}, {});
  return data;
};
// edit Number Format Setting
export const updateNumberFormatSettingApi = async (params: IUpdateCustomerFormatNumber) => {
  const { data } = await ApiClient.postJsonData('/v1/customerNumberFormatApi/', {}, params);
  return data;
};
// get customer reverberation courses
export const getReverberationsCourses = async (contractCourseCategoryId = ''): Promise<IReserberationCourse[]> => {
  const { data } = await ApiClient.get('/v1/customerReverberations/courses', {}, { contractCourseCategoryId });
  return data;
};
// get customer reverberation staff
export const getReverberationStaffs = async (params?: { targetDate: string}): Promise<IReserberationStaff[]> => {
  const { data } = await ApiClient.get('/v1/customerReverberations/staffs', params || { targetDate: moment().format('YYYY-MM-DD') });
  return data;
};
// get Customer ReverberationInfo
export const getReverberationApi = async (customerBasicDataId: string): Promise<IReverberationInfo> => {
  // const companyCode = getSessionStorage('companyCode');
  const { data } = await ApiClient.get('/v1/customerReverberations', { customerBasicDataId });
  return data;
};
export const getReserberationCategoryCourses = async (): Promise<IReserberationCourse[]> => {
  const { data } = await ApiClient.get('/v1/customerReverberations/courseCategorys', {}, {});
  return data;
};
export const postCustomerReverberations = async (request: IRequestType, companyCode: string) => {
  const { data } = await ApiClient.postJsonData(`/v1/customerReverberations/${companyCode}`, {}, request);
  return data;
};

// ExportCSV

export const exportCSVCustomerApi = async (CustomerExportOptions: any, CustomerBasicDataIds: any, fileName: string, isFromAdvancedSearch: boolean = true): Promise<void> => {
  const companyCode = getSessionStorage('companyCode');
  const customerID = CustomerBasicDataIds?.length > 0 ? CustomerBasicDataIds : null;
  if (isFromAdvancedSearch) {
    switch (CustomerExportOptions.customerExportOptions) {
      case 'CONTRACT_HISTORY':
        await ApiClient.downloadCsvBody('/v1/customerContractHistory/csv', {}, fileName, customerID);
        break;
      case 'ACCOUNTING_HISTORY':
        await ApiClient.downloadCsvBody('/v1/accountingSlips/customerAccountingHistory/csv', {}, fileName, customerID);
        break;
      case 'PRODUCT_SALE_PURCHASE_HISTORY':
        await ApiClient.downloadCsvBody('/v1/accountingSlips/customerPurchaseHistory/csv', {}, fileName, customerID);
        break;
      case 'TICKET_DEGESTION_INFORMATION':
        await ApiClient.downloadCsvBody('/v1/accountingSlips/customerTicketDigestionHistory/csv', {}, fileName, customerID);
        break;
      case 'REVERBERATION_INFORMATION':
        await ApiClient.downloadCsvBody('/v1/customerReverberations/csv', {}, fileName, customerID);
        break;
      case 'RESERVATION_HISTORY':
        await ApiClient.downloadCsvBody('/v2/reservations/csv', {}, fileName, customerID);
        break;
      case 'CUSTOMER_VISIT_INFORMATION':
        await ApiClient.downloadCsvBody('/v1/accountingSlips/customerVisit/csv', {}, fileName, customerID);
        break;
      case 'SALON_HISTORY':
        await ApiClient.downloadCsvBody('/v1/accountingSlips/customerSalonHistory/csv', {}, fileName, customerID);
        break;
      default:
        // eslint-disable-next-line no-case-declarations
        const CustomerExportOptionsNew = { ...CustomerExportOptions, CustomerExportOptions: CustomerExportOptions?.customerExportOptions };
        // eslint-disable-next-line no-param-reassign
        delete CustomerExportOptions.customerExportOptions;
        await ApiClient.downloadCsvBody(`/v2/customers/csv/${companyCode}`, CustomerExportOptionsNew, fileName, CustomerBasicDataIds);
        break;
    }
  } else {
    // export CSV Customer list from  Form Search
    if (!CustomerExportOptions?.orgIds) {
      // eslint-disable-next-line no-param-reassign
      delete CustomerExportOptions.orgIds;
      // eslint-disable-next-line no-param-reassign
      CustomerExportOptions.applyForUnderOrg = false;
    }
    await ApiClient.downloadOriginalCsv(`/v3/customers/csv/${companyCode}`, CustomerExportOptions, fileName);
  }
};


// Product sales purchase history
export const productSalesPurchaseHistoryListApi = async (params: IReservationHistoryParams): Promise<IReservationHistory[]> => {
  const { data } = await ApiClient.get('/v1/accountingSlips/customerAccountingItemDetail', params, {});
  return data;
};


// Get Medical Record Detail
export const getMedicalRecordDetailApi = async (customerBasicDataID: string, counselingCategory: string, karteNumber: string): Promise<IMedicalRecordDetail> => {
  const { data } = await ApiClient.get(`/v1/customers/${customerBasicDataID}/medicalRecords/${counselingCategory}/${karteNumber}`, {});
  return data;
};

export const getKarteCounselingFlagMastersApi = async (counselingCategory: string = 'FACE'): Promise<IKarteCounselingFlag[]> => {
  const { data } = await ApiClient.get('/v1/karteCounselingFlagMasters', {}, { counselingCategory }); // FACE, BODY, BODY_SKIN
  return data;
};


export const postMedicalRecordsApi = async (request: IFormMedicalRecord, customerBasicDataID: string) => {
  const { data } = await ApiClient.postJsonData(`/v1/customers/${customerBasicDataID}/medicalRecords`, {}, request);
  return data;
};


export const updateMedicalRecordsApi = async (request: IFormMedicalRecordUpdate, customerBasicDataID: string) => {
  const { data } = await ApiClient.putJsonData(`/v1/customers/${customerBasicDataID}/medicalRecords`, {}, request);
  return data;
};

export const uploadImageFileApi = async (file: File, counselingCategory: string, customerBasicDataID:string): Promise<any> => {
  const { data } = await ApiClient.postMutipartData(`/v1/customers/${customerBasicDataID}/medicalRecords/${counselingCategory}/images`, {}, { image: file });
  return data;
};


export const deleteMedicalRecordApi = async (customerBasicDataID:string, counselingCategory: string, karteNumber: string): Promise<any> => {
  const { data } = await ApiClient.delete(`/v1/customers/${customerBasicDataID}/medicalRecords/${counselingCategory}/${karteNumber}`, {});
  return data;
};


export const getKarteCounselingConsiderationsApi = async (customerBasicDataID:string, counselingCategory: string): Promise<any> => {
  const { data } = await ApiClient.get(`/v1/customers/${customerBasicDataID}/karteCounselingConsiderations/${counselingCategory}`, {}, {}); // FACE, BODY, BODY_SKIN
  return data;
};

// 注意事項だけを保存する（カルテの登録・更新とは独立）
export const updateKarteCounselingConsiderationsApi = async (customerBasicDataID:string, counselingCategory: string, considerations: string): Promise<any> => {
  const { data } = await ApiClient.putJsonData(`/v1/customers/${customerBasicDataID}/karteCounselingConsiderations/${counselingCategory}`, {}, { considerations }); // FACE, BODY, BODY_SKIN
  return data;
};


export const getUsingServiceStatisticApi = async (customerBasicDataID:string, statisticDay: string): Promise<any> => {
  const { data } = await ApiClient.get(`/v1/customers/${customerBasicDataID}/usingServiceStatistic/${statisticDay}`, {}, { });
  return data;
};

export const getConsiderationsApi = async (customerBasicDataID:string, counselingCategory: string, params: any): Promise<any> => {
  const { data } = await ApiClient.get(`/v1/customers/${customerBasicDataID}/medicalRecords/${counselingCategory}?sort=registration_date,DESC&sort=create_date,DESC`, params);
  return data;
};

export const createCustomerAttechedSheetApi = async (params: IParamsCreateApiAttachedSheet) => {
  const { data } = await ApiClient.postMutipartData('/v1/karteSheetInfo', {}, params);
  return data;
};


export const getDownloadPDFMedicalRecordAPI = async (params: any, fileName: string): Promise<void> => {
  await ApiClient.downloadOriginalPdf('/v1/customers/medicalRecordsPdf', params, fileName);
};


export const getCurrentPointApi = async (customerBasicDataID:string): Promise<any> => {
  const { data } = await ApiClient.get(`/v1/customers/${customerBasicDataID}/currentPoint`, {}, {});
  return data;
};

export const getContractFlatRateListApi = async (param:{customerBasicDataId: string, page: number, size: number}): Promise<ContractFlatRateResponse> => {
  const { data } = await ApiClient.get('/v1/customerReverberations/getContractFlatRateList', param, {});
  return data;
};
